import { EffectCallback, useEffect } from 'react';

export const useOnMount = (action: EffectCallback) => {
  useEffect(() => {
    return action();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
